import React, { useContext } from 'react'

import { ROUTES } from '../shared/constants'
import { Box, IconButton, makeStyles, Tabs, Tab, StepLabel, Stepper, Typography, Grid, Select, MenuItem, FormControlLabel, Checkbox } from '@material-ui/core'
import EditIcon from '@material-ui/icons/Edit'

import ActionButton from './ActionButton'
import { useHistory } from 'react-router'
import { UserContext } from '../context api/UserContext'
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#EFF3FE',
    borderRadius: '10px',
  },
  tab: {
    textTransform: 'none',
    fontFamily: 'Open sans',
    fontSize: '16px',
    fontWeight: '400',
    lineHeight: '20px',
  },
  tabs: {
    '& > span': {
      maxWidth: '50px',
      width: '100%',
    },
    input: {
      '&:focus': {
        outline: 'none',
      },
    },
  },
}))
function HeaderTabLayout({ heading, content, addContent, view, text, url, lead, redirect, state = {}, setState= ()=>{},  loading, buttonDisabled}) {
  const classes = useStyles()
  const history = useHistory()
  const user = useContext(UserContext)
  const userType = (user && user.user && user.user.userType === 'COMPANYADMIN') || user.user.userType === 'MODULEADMIN'
  let validStatus = false
  Object.values(state).forEach((value) => {
    if (value !== 0 && value !== false && !value && value === null) validStatus = true
  })

  return (
    <div style={{ margin: '0px 20px 20px 20px' }}>
      <Grid lg={12} container className={classes.root}>
        <Grid item lg={12} style={{ borderBottom: '1px solid #CCCCCC', padding: '20px', paddingBottom: '10px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography style={{ fontWeight: 600 }}>{heading}</Typography>
            {view && url && userType && (
              <div
                style={{
                  cursor: 'pointer',
                  border: '1px solid #CCCCCC',
                  width: '30px',
                  height: '30px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignContent: 'center',
                  borderRadius: '5px',
                  paddingTop: '2px',
                }}
              >
                <EditIcon onClick={() => history.push(url)} />
              </div>
            )}
          </div>
        </Grid>
        <Grid item lg={12} style={{ padding: '5px 21px' }}>
          {content}
        </Grid>
        {!view && (
          <Grid item lg={12} style={{ margin: '0px 0px 30px 20px' }}>
            <ActionButton disableButton={validStatus || buttonDisabled} redirect={redirect} text={text} handleSubmit={addContent} loading={loading} state = {state} setState = {setState}/>
          </Grid>
        )}
      </Grid>
    </div>
  )
}

export default HeaderTabLayout
